export default __webpack_public_path__ + "static/media/maxime_climb.69cb945d.jpg";